import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { EMPTY_ARRAY } from '#pplx/frontend/common/defaults.js';
import { logger } from '#pplx/frontend/logger/browser.js';
import { autosuggestHealthClient } from '#pplx_generated/typespec/rest/autosuggest/health/client.js';
export const getHealthSuggestions = async ({ reason, }) => {
    try {
        const { data, error, response } = await autosuggestHealthClient.GET('/rest/autosuggest/health/list-autosuggest', reason, {
            params: {
                query: {
                    query: '',
                },
            },
            timeoutMs: 0,
        });
        if (error) {
            throw new ApiClientsError('API_CLIENTS_ERROR', {
                cause: error,
                status: response.status ?? 0,
            });
        }
        return (data?.results ?? EMPTY_ARRAY).map((result, index) => ({
            query: result.query || `suggestion-${index}`,
            query_uuid: result.query_uuid ?? undefined,
            category: result.category ?? undefined,
        }));
    }
    catch (err) {
        logger.error(err);
        return [];
    }
};
//# sourceMappingURL=getHealthSuggestions.js.map